module.exports = __webpack_public_path__ + "static/media/empty-blue.e845126c.svg";